<template>
    <div>

        <div id="hero-banner">
            <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
            <div class="overlay text-center">
                <h1 id="hero-text">Partner with us</h1>
            </div>
        </div>

        <div id="innovative-features-section" class="pt-7 pb-7">
            <div class="container-fluid text-default">
                <div class="row">
                    <div class="col-lg-6 text-right d-none d-lg-block">
                        <div class="parallax mb-7" data-speed="0.1" data-initial-offset="-150">
                            <img :src="registerImages[0]" class="parallax-item shadow-diffused-lg" style="width:550px">
                        </div>
                        <div class="parallax" data-speed="0.18" data-initial-offset="-350">
                            <img :src="registerImages[1]" class="parallax-item shadow-diffused-lg" style="width:550px">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <h2 class="text-default display-4 montserrat-bold text-uppercase mb-3">
                            Why <span class="text-danger inline">partner</span> with us?
                        </h2>
                        <p class="font-weight-400">As a Cutiefy accredited service provider, you will enjoy all these benefits!</p>
                        <div class="features-section">
                            <span class="icon-bullet-icon">1</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Able to reach the growing market of mobile users and be one of the first to use this revolutionary channel for the beauty industry.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">2</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Increase your visibility and connect with new customers in an easier and more accessible way through the Cutiefy Mobile App Platform.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">3</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Be listed and receive bookings by being visible only during your lean or available hours.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">4</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Upload your profile and photos and advertise your latest promos for free on your own mini-site on the Cutiefy App.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">5</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Benefit from Cutiefy’s digital marketing campaigns.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">6</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Use the management tool to manage your business hours, appointments, services and pricing.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">7</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Increase employee productivity by using the management tool to manage their tasks, schedules, attendance and performance.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">8</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Manage walk-ins and phone-ins and appointments made through the Cutiefy Mobile App by viewing and assigning available timeslots in the calendar.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">9</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Payment collections are managed through Cutiefy for transactions done only through the Cutiefy Mobile App.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">10</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">Generate booking & sales reports, employee attendance and completed employee assignments.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">11</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="font-weight-400">As we only work with legitimate and professional service providers, being a Cutiefy accredited service provider brings more credibility and prestige.</div>
                            </div>
                        </div>
                        <div class=" mt-4">
                            <router-link to="/partners/form" v-slot="{ href, navigate }">
                                <a class="btn btn-danger btn-lg ml-6" :href="href"  @click="navigate">BE A CUTIEFY ACCREDITED SERVICE PROVIDER</a>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { resource } from "@utils/network";
export default {
    name: "PartnersPage",

    data: () => ({
        registerImages: [
            resource('images/register_03.jpg'),
            resource('images/register_04.jpg')
        ],
        bannerStyle: `background-image:url('${ resource("images/register-banner-FB.jpg") }')`
    })
}
</script>

<style scoped lang="css">
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
    }
    #hero-text {
        margin-top: 400px;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }

    .features-section {
        margin-top: 30px
    }
    .features-section .icon-bullet-icon {
        font-family: 'Montserrat', sans-serif;
    }
</style>